import {
  DELETE_COUPON_BY_ID_REQUEST,
  DELETE_COUPON_BY_ID_SUCCESS,
  DELETE_COUPON_BY_ID_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DELETE_COUPON_BY_ID_REQUEST:
      return { ...state, isLoading: true, error: null };
    case DELETE_COUPON_BY_ID_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case DELETE_COUPON_BY_ID_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};